class BaseRetencionInputPipe {
  getName() {
    return 'retencion';
  }

  apply(data) {
    if (!!data.Complemento) {
      delete data.Complemento?.TimbreFiscalDigital;
    }

    delete data.Metadata;
    delete data.Idx;
    delete data.FolioInt;
    delete data.signature;

    const { ImpRetenidos = [] } = data.Totales ?? {};
    const ivaValue = ImpRetenidos.filter((item) => item.ImpuestoRet !== '001');
    const isrValue = ImpRetenidos.filter((item) => item.ImpuestoRet !== '002');

    data.Totales.iva = ivaValue.pop();
    data.Totales.isr = isrValue.pop();
    data.Totales.ImpRetenidos = undefined;

    data.FechaExp = undefined;
    data.FechaTemp = new Date();
    data.CfdiFecha = undefined;

    return data;
  }
}

export default BaseRetencionInputPipe;
